<ng-container *ngIf="!item.hidden">

    <div class="group-title" [ngClass]="item.classes">
        <span class="hint-text" [translate]="item.translate">{{item.title}}</span>
    </div>

    <div class="group-items">
        <ng-container *ngFor="let item of item.children">
            <fuzz-nav-vertical-group *ngIf="item.type=='group'" [item]="item"></fuzz-nav-vertical-group>
            <fuzz-nav-vertical-collapsable *ngIf="item.type=='collapsable'"
                                           [item]="item"></fuzz-nav-vertical-collapsable>
            <fuzz-nav-vertical-item *ngIf="item.type=='item'" [item]="item"></fuzz-nav-vertical-item>
        </ng-container>
    </div>

</ng-container>
